module.exports = __webpack_public_path__ + "img/mailgun.010ebe34.png";